export function createShareImage({ article, env, isVk = false, }) {
    if (!article.id) {
        console.error('[createShareImage]: There is no article id');
        return '';
    }
    const { id, changed } = article || {};
    return `${env.CDN_URL || ''}/forbes-static/shareimages${isVk ? '/vk/' : '/'}${id}.jpg?v=${changed || 0}`;
}
